/**
 * bulkUpdateRecords (client)
 *
 * Thin wrapper over the `bulkUpdateRecords` cloud function used by the Records
 * page selection bar. Callers pass either explicit record IDs (ticked rows) or
 * a filter ("select all matching"); the server resolves the filter to IDs via
 * Algolia and applies the action in chunked batches. Mirrors fetchRecordsList.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebaseFunctions';
import { awaitAuthReady } from '@/services/auth/awaitAuthReady';
import type {
    BulkUpdateRecordsRequest,
    BulkUpdateRecordsResponse,
} from '#types';

export const bulkUpdateRecords = async (
    request: BulkUpdateRecordsRequest,
): Promise<BulkUpdateRecordsResponse> => {
    await awaitAuthReady();
    const callable = httpsCallable<BulkUpdateRecordsRequest, BulkUpdateRecordsResponse>(
        functions,
        'bulkUpdateRecords',
    );
    const result = await callable(request);
    return result.data;
};
